import { FlexRow } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'

import { AuctionCard } from '../../../Components'
import ComponentSize from '../../../ComponentSize'
import { AuctionProvider } from '../../../Contexts'
import { ComponentSizeHeader } from '../../../Toolbar'
import WorldBasePage from '../../WorldBasePage'

const AuctionCardPage: React.FC = () => {
  const { id, size } = useParams()
  const quadkeyRequested = Quadkey.fromBase4String(id) ?? Quadkey.root

  return (
    <AuctionProvider quadkey={quadkeyRequested}>
      <WorldBasePage>
        <Helmet title="Auction Card" />
        <ComponentSizeHeader />
        <FlexRow>
          <AuctionCard quadkey={quadkeyRequested} size={size as ComponentSize} />
        </FlexRow>
      </WorldBasePage>
    </AuctionProvider>
  )
}

export default AuctionCardPage
